import React, { FC, useState } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { Widget } from "@typeform/embed-react";

import { ReactComponent as Welcome } from "../../../assets/illustrations/welcome-240x240.svg";
import { Button } from "../../../components/common";
import { ONBOARDING_SURVEY_ID } from "../../../constants";
import ServicesLayout from "../../../layouts/Services.layout";
import { ROUTES } from "../../../routes";
import { selectCurrentUser } from "../../../store/reducers/user";

export const PhoneConfirmedPage: FC = () => {
  const [isSurveyCompleted, setIsSurveyCompleted] = useState(false);
  const { email, marketing_data, phone_country } =
    useSelector(selectCurrentUser);

  const plainContent = phone_country !== "IN"; // toggle as desired inconjunction with value in ActivationOutlet

  const hiddenFields = {
    email,
    utm_source: marketing_data?.utm_source || "",
    utm_medium: marketing_data?.utm_medium || "",
    utm_campaign: marketing_data?.utm_campaign || "",
    phone_country,
  };

  const handleSubmit = () => {
    setIsSurveyCompleted(true);
  };

  const content = plainContent ? (
    <>
      Thank you, your phone is confirmed!
      <Button
        component={NavLink}
        to={ROUTES.HOME}
        variant={Button.variant.PRIMARY}
      >
        Continue
      </Button>
    </>
  ) : isSurveyCompleted ? (
    <>
      Thanks a lot! We appreciate your feedback.
      <Button
        component={NavLink}
        to={ROUTES.HOME}
        variant={Button.variant.PRIMARY}
      >
        Continue
      </Button>
    </>
  ) : (
    <>
      Please, take a few seconds on our survey and help us improve your
      experience.
      <Widget
        id={ONBOARDING_SURVEY_ID || ""}
        style={{ width: "100%", height: "60vh" }}
        onSubmit={handleSubmit}
        hidden={hiddenFields}
      />
    </>
  );

  return (
    <ServicesLayout
      image={isSurveyCompleted && <Welcome />}
      title="Your account is ready!"
    >
      <div className="text-base theme-text-secondary flex flex-col gap-8 items-center">
        {content}
      </div>
    </ServicesLayout>
  );
};
